let Auth = {

  isAdmin () {
    return this.getFromLocalStorage('admin')
  },

  setAdmin (admin) {
    this.saveToLocalStorage('admin', admin)
  },

  getToken () {
    return this.getFromLocalStorage('sessionKey')
  },

  setToken (token) {
    this.saveToLocalStorage('token', token)
  },

  getFromLocalStorage (key) {
    return localStorage.getItem(key)
  },

  saveToLocalStorage (key, value) {
    localStorage.setItem(key, value)
  },

  removeAfterLogout () {
    localStorage.removeItem('sessionKey')
    localStorage.removeItem('sessionAccessToken')
    localStorage.removeItem('sessionRefreshToken')
  },

  isAuthenticated () {
    // console.log('undef?', this.getToken())
    if (this.getFromLocalStorage('sessionRefreshToken')) {
      return true
    } else {
      return false
    }
  }
}

Auth.install = function (Vue) {
  Vue.prototype.$auth = Auth
}

export default Auth



// WEBPACK FOOTER //
// ./src/services/auth.js